export default "__VITE_ASSET__a8b86d38__"